export default __webpack_public_path__ + "static/dog-a379ab68f34cf3ecc684d7721be98c69.jpeg";